// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content-login-page {
  padding-top: 7em;
}

.login-page-logo {
  float: left;
  width: 194px;
  /* margin-top: 6vh; */
}

.login-section {
  margin-top: 1em;
}

.login-section h1,
.login-section h2 {
  font-weight: 700;
}

.login-section h2 {
  font-size: 1.4em;
}

.form-login-forget a {
  color: #db0b27;
  font-weight: 500;
  text-decoration: none;
}

.form-login-register {
  text-align: center;
}

.form-login-register p {
  margin-bottom: 0;
}

.login-help-text {
  color: #6b6c6d;
  font-size: 0.9em;
  text-align: center;
}

.login-help-text-link {
  color: #6b6c6d;
  font-weight: 700;
  text-decoration: none;
}

.form-login-register a {
  font-weight: 700;
  text-decoration: none;
}

.toggle-password {
  float: right;
  margin-right: 15px;
  margin-top: -2.7em;
  position: relative;
  z-index: 2;
  cursor: pointer;
  opacity: 0.6;
  transition: opacity 0.3s;
}

.toggle-password img {
  max-width: 30px;
}

.form-floating > .form-control:focus + .toggle-password {
  opacity: 1;
  transition: opacity 0.3s;
}

.was-validated .form-control:valid + .toggle-password,
.form-control.is-valid + .toggle-password,
.was-validated .form-control:invalid + .toggle-password,
.form-control.is-invalid + .toggle-password {
  margin-right: 35px;
}

.go-back-link {
  color: #db0b27;
  font-weight: 800;
  font-size: 0.9rem;
}

.alert-warning-login {
  color: #d68c49;
  background-color: #fff3cd;
  border-color: #ffecb5;
  font-size: 0.9em;
  text-align: left;
}

.alert-primary-login {
  color: #3a87ad;
  background-color: #cfe2ff;
  border-color: #b6d4fe;
  font-size: 0.9em;
}

.alert-danger-login {
  color: #a94442;
  background-color: #f2dede;
  border-color: #ebccd1;
  font-size: 0.9em;
}

.alert-success-login {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  font-size: 0.9em;
}

.warning-icon-label {
  width: 1.3em;
  margin-right: 0.5em;
  vertical-align: top;
}

.no-email {
  color: #db0b27;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
}

.verify-text-info {
  color: rgba(43, 54, 59, 0.5);
}

.verify-text-email-data {
  font-weight: 700;
  margin-top: -1em;
}

.verify-text-info-link {
  color: #db0b27;
  font-weight: 500;
  cursor: pointer;
}

.verify-modal-title {
  font-weight: 900;
  font-size: 1.3rem;
}

/* BREAKPOINT ESCRITORIO */
@media (min-width: 992px) {
  .login-page-logo {
    float: left;
    width: 194px;
    /* margin-top: 6vh; */
  }

  .content-login-page {
    padding-top: 3.06em;
  }

  .form-login-btn {
    width: 70%;
  }

  .form-login-register {
    text-align: left;
  }

  .form-login-register p {
    display: inline;
    margin-right: 0.5em;
  }

  .login-container {
    margin-top: 1em !important;
  }

  .login-header-container {
    display: flex;
    justify-content: space-between;
  }
  .login-help-text {
    text-align: left;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/login/login.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE;IACE,WAAW;IACX,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;EACA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".content-login-page {\r\n  padding-top: 7em;\r\n}\r\n\r\n.login-page-logo {\r\n  float: left;\r\n  width: 194px;\r\n  /* margin-top: 6vh; */\r\n}\r\n\r\n.login-section {\r\n  margin-top: 1em;\r\n}\r\n\r\n.login-section h1,\r\n.login-section h2 {\r\n  font-weight: 700;\r\n}\r\n\r\n.login-section h2 {\r\n  font-size: 1.4em;\r\n}\r\n\r\n.form-login-forget a {\r\n  color: #db0b27;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n}\r\n\r\n.form-login-register {\r\n  text-align: center;\r\n}\r\n\r\n.form-login-register p {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.login-help-text {\r\n  color: #6b6c6d;\r\n  font-size: 0.9em;\r\n  text-align: center;\r\n}\r\n\r\n.login-help-text-link {\r\n  color: #6b6c6d;\r\n  font-weight: 700;\r\n  text-decoration: none;\r\n}\r\n\r\n.form-login-register a {\r\n  font-weight: 700;\r\n  text-decoration: none;\r\n}\r\n\r\n.toggle-password {\r\n  float: right;\r\n  margin-right: 15px;\r\n  margin-top: -2.7em;\r\n  position: relative;\r\n  z-index: 2;\r\n  cursor: pointer;\r\n  opacity: 0.6;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.toggle-password img {\r\n  max-width: 30px;\r\n}\r\n\r\n.form-floating > .form-control:focus + .toggle-password {\r\n  opacity: 1;\r\n  transition: opacity 0.3s;\r\n}\r\n\r\n.was-validated .form-control:valid + .toggle-password,\r\n.form-control.is-valid + .toggle-password,\r\n.was-validated .form-control:invalid + .toggle-password,\r\n.form-control.is-invalid + .toggle-password {\r\n  margin-right: 35px;\r\n}\r\n\r\n.go-back-link {\r\n  color: #db0b27;\r\n  font-weight: 800;\r\n  font-size: 0.9rem;\r\n}\r\n\r\n.alert-warning-login {\r\n  color: #d68c49;\r\n  background-color: #fff3cd;\r\n  border-color: #ffecb5;\r\n  font-size: 0.9em;\r\n  text-align: left;\r\n}\r\n\r\n.alert-primary-login {\r\n  color: #3a87ad;\r\n  background-color: #cfe2ff;\r\n  border-color: #b6d4fe;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.alert-danger-login {\r\n  color: #a94442;\r\n  background-color: #f2dede;\r\n  border-color: #ebccd1;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.alert-success-login {\r\n  color: #3c763d;\r\n  background-color: #dff0d8;\r\n  border-color: #d6e9c6;\r\n  font-size: 0.9em;\r\n}\r\n\r\n.warning-icon-label {\r\n  width: 1.3em;\r\n  margin-right: 0.5em;\r\n  vertical-align: top;\r\n}\r\n\r\n.no-email {\r\n  color: #db0b27;\r\n  cursor: pointer;\r\n  font-weight: 500;\r\n  text-decoration: none;\r\n}\r\n\r\n.verify-text-info {\r\n  color: rgba(43, 54, 59, 0.5);\r\n}\r\n\r\n.verify-text-email-data {\r\n  font-weight: 700;\r\n  margin-top: -1em;\r\n}\r\n\r\n.verify-text-info-link {\r\n  color: #db0b27;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n}\r\n\r\n.verify-modal-title {\r\n  font-weight: 900;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n/* BREAKPOINT ESCRITORIO */\r\n@media (min-width: 992px) {\r\n  .login-page-logo {\r\n    float: left;\r\n    width: 194px;\r\n    /* margin-top: 6vh; */\r\n  }\r\n\r\n  .content-login-page {\r\n    padding-top: 3.06em;\r\n  }\r\n\r\n  .form-login-btn {\r\n    width: 70%;\r\n  }\r\n\r\n  .form-login-register {\r\n    text-align: left;\r\n  }\r\n\r\n  .form-login-register p {\r\n    display: inline;\r\n    margin-right: 0.5em;\r\n  }\r\n\r\n  .login-container {\r\n    margin-top: 1em !important;\r\n  }\r\n\r\n  .login-header-container {\r\n    display: flex;\r\n    justify-content: space-between;\r\n  }\r\n  .login-help-text {\r\n    text-align: left;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
